import { userConfigAction } from './actions';

const INITIAL_STATE: InitialStateUser = {
  user:{
    userCPF: '',
    userId: '',
    hasToken: false,
    userPJ:false,
    userName: '',
    creditorId: ''
  },
  errorToken:false,
  errorDigit:false,
};

export default function data(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case 'persist/PURGE':
      return INITIAL_STATE;
    case userConfigAction.getUser:
      return { ...state, user:action.payload };
    case userConfigAction.confirmErrorToken:
      return { ...state, errorToken:action.payload };
    case userConfigAction.confirmErrorDigit:
      return { ...state, errorDigit:action.payload };
    default:
      return state;
  }
}
